import React, { Fragment, memo } from 'react';
import { withRouter } from 'react-router-dom';

//Componentes
import Botones from '../../../components/UI/botonera/headerBotones.js';
import ListaDatos from '../../../components/UI/listaDatosBusqueda/index.jsx'
function ControlLista(props) {
    return (
        <Fragment>
            <div className="col-md-12">
                <div className='row'>
                    <div className="col-md-6">
                        <h1>{props.titulo}</h1>
                    </div>
                    <div className="col-md-6 text-right">
                        <div className="acciones">
                            <Botones
                                botones={props.botones}
                            />
                        </div>
                    </div>
                </div>
                <div className="content">
                    <div className="content-box box-primary">
                        <div className="row">
                            <div className='col-xs-12'>
                                <div id="master-tabla" className="table-responsive  col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <ListaDatos
                                        id={props.id}
                                        datos={props.datos}
                                        columnas={props.columnas}
                                        striped={false}
                                        hover={true}
                                        condensed={false}
                                        selectRow={props.selectRow}
                                        onDoubleClick={props.onDoubleClick}
                                        borrar={props.borrando}
                                        verLHOC={props.verLHOC}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
export default memo(ControlLista);